<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title
      [innerHTML]="(displayAddress$ | async) || 'Analytics'"
    ></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ProfitDetails">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h2 class="Header">Financial</h2>
        <p>Powerful insight into the profitability of your properties</p>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-12 ProfitDetails__CardColumn">
        <!-- <ion-card class="ProfitDetails__Card">
        <smartflip-financial-aggregates></smartflip-financial-aggregates>
      </ion-card> -->

        <ion-card class="ProfitDetails__Card">
          <ion-card-header>
            <ion-card-title>Profit Percentage</ion-card-title>
            <ion-card-subtitle>
              Costs vs profit (if held full term)<br />
              as a % of
              <b
                ><span
                  [innerHTML]="
                    sellingPrice | currency: 'USD' : 'symbol' : '1.0-0'
                  "
                ></span
              ></b>
            </ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            @if (purchasePrice <= 0) {
              <p>
                <em [innerHTML]="missingDataText"></em>
              </p>
            } @else {
              <app-chart
                [chartData]="profitData"
                [chartLabels]="profitLabels"
                #piechart
              ></app-chart>
            }
          </ion-card-content>
        </ion-card>

        <ion-card class="ProfitDetails__Card">
          <ion-card-header>
            <ion-card-title>Profit Over Time</ion-card-title>
            <ion-card-subtitle
              >Profit Loss due to Carrying Costs Over Time</ion-card-subtitle
            >
          </ion-card-header>
          <ion-card-content>
            @if (purchasePrice <= 0 || sellingPrice <= 0) {
              <p>
                <em [innerHTML]="missingDataText"></em>
              </p>
            } @else {
              <app-chart
                [chartType]="chartTypeBar"
                [chartData]="carryingData"
                [chartLabels]="carryingLabels"
                [chartBackgrounds]="backgrounds"
                #linechart
              ></app-chart>
            }
          </ion-card-content>
        </ion-card>
      </div>
    </div>
  </div>
</ion-content>
